export default function (fileName) {
    return fileName.substring(0, fileName.lastIndexOf('.'));
}
